import React, { PureComponent, Fragment } from 'react';
import injectSheet from 'react-jss';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import { Card, Spin, Button, Typography, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import numberWithSpaces from 'src/utils';
import moment from 'moment';
import styles from './styles';
const { Title, Text } = Typography;
const data = {
	labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
	datasets: [
		{
			label: 'My First dataset',
			backgroundColor: 'rgba(255,99,132,0.2)',
			borderColor: 'rgba(255,99,132,1)',
			borderWidth: 1,
			hoverBackgroundColor: 'rgba(255,99,132,0.4)',
			hoverBorderColor: 'rgba(255,99,132,1)',
			data: [65, 59, 80, 81, 56, 55, 40]
		}
	]
};

import { getTopAffectCompany } from 'src/redux/actions/dashborad.js';

//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { render } from 'less';

function mapStateToProps(state) {
	return {
		store: {
			affectCompany: state.dashboard.affectCompany
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				// getListCreditDetails
				getTopAffectCompany
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class CharCompany extends PureComponent {
	state = {
		loading: true,
		setLimit: 0, // Limit par defaut
		defaultLimit: 10, // nb données à affiché 
		displayBtn: false, // afficher boutton 
		disabledBtn: false, // Désactivé boutton
		setBackgroundColorChart: [ // couleur des barres du graphique
			"rgba(1,173,125,0.5)", "rgba(133,133,133,0.5)", "rgba(255,158,13,0.5)"
		]
	};

	filter = {
		limit: 1,
		month: 8,
		year: 2019
	};

	componentDidMount() {
		const filter = this.filter;
		this.handelGetTopAffectCompany(filter);
	}

	handelGetTopAffectCompany = filter => {
		const payload = {
			// limit: this.state.setLimit
		};
		this.setState({ loading: true });
		this.props.action.getTopAffectCompany(
			payload,
			() => {
				this.setState({ loading: false });
			},
			() => {
				this.setState({ loading: false });
			}
		);
	};

	convertDataForChart = data => {
		let outPut = {
			labels: [],
			datasets: [
				{
					label: 'Company',
					backgroundColor: this.state.setBackgroundColorChart,
					data: [],
				}
			]
		};
		if (data.length > 0) {
			data.map(e => {
				if (typeof e.name === 'string' && e.name.length > 12) {
					// outPut.labels.push(`${e.name.slice(0, 15)}...`);
					outPut.labels.push(
						{
							label: `${e.name.slice(0, 15)}...`,
							total: e.sum_amount
						}
					)
				} else {
					// outPut.labels.push(e.name);
					outPut.labels.push(
						{
							label: e.name,
							total: e.sum_amount
						}
					)
				}
				// outPut.labels.push(e.name);
				outPut.datasets[0].label = `${e.month}/${e.year}`;
				outPut.datasets[0].data.push(
					parseInt(e.sum_amount, 10)
				);
			});
		}
		return outPut;
	};

	dataChartLimit = (setLimit) => {
		const {
			classes,
			store: {
				affectCompany: { data = [] }
			}
		} = this.props;
		// return data.slice(0, setLimit)
		const limitRange = []; // set range limit 
		const valueRange = Math.trunc(data.length / this.state.defaultLimit) + 1; // get number range
		let varLimit = 0
		// (setLimit <= data.length) ?  limitRange.push(5*limitRange.length) : ''

		// set value of range
		for (let i = 0; i < valueRange; i++) {
			limitRange.push(this.state.defaultLimit * i)
		}

		// compare value limit & value of range
		limitRange.forEach(element => {
			if (setLimit == element) {
				return varLimit = element
			}
		});
		if (Math.sign(data.length - (this.state.setLimit + this.state.defaultLimit)) == -1 || Math.sign(data.length - (this.state.setLimit + this.state.defaultLimit)) == 0) {
			return this.setState({ disabledBtn: true }), (setLimit == varLimit) ? data.slice(setLimit, setLimit + this.state.defaultLimit) : data.slice(0, setLimit)
		}
		else {
			return this.setState({ disabledBtn: false }), (setLimit == varLimit) ? data.slice(setLimit, setLimit + this.state.defaultLimit) : data.slice(0, setLimit)
		}

	}

	setDefaultDataChart = () => {
		const {
			classes,
			store: {
				affectCompany: { data = [] }
			}
		} = this.props;

		// if (data.length < 2 || data.length == this.state.setLimit) {
		// 	this.setState({ disabledBtn: true })
		// } else {
		// 	this.setState({ disabledBtn: false })
		// }

		data.forEach(element => {
			this.state.setBackgroundColorChart.push("rgba(1,173,125,0.5)", "rgba(133,133,133,0.5)", "rgba(255,158,13,0.5)")
		});

		// display button 'Afficher moins'
		return (this.state.displayBtn == true && data.length > this.state.defaultLimit)
			?
			<>
				< Button
					icon="minus"
					style={{ color: 'red' }}
					type='link'

					onClick={() => this.setState({ setLimit: 0, displayBtn: false })}
				>
					Afficher moins
				</Button >
			</>
			:
			<></>

	}



	render() {
		const {
			classes,
			store: {
				affectCompany: { data = [] }
			}
		} = this.props;

		const { loading } = this.state;
		const limitChart = this.state.setLimit
		const colorsTest = []
		const options = {
			legend: {
				display: false,
			},
			scales: {
				maxBarThickness:1,
				yAxes: [
					{
						gridLines: {
							display: true,
						},
						ticks: {
							fontSize: 15,
							callback(value) {
								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								return numberWithSpaces(value.label);
							}
						}
					},
					{
						type: 'category',
						position: 'right',
						ticks: {
							fontSize: 15,
							callback(value) {
								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								return numberWithSpaces(value.total)
							}
						},
						offset: true,
						gridLines: {
							display: false,
						}
					}
				],
				xAxes: [
					{
						// display:false,
						gridLines: {
							display: true,
							// drawTicks:false,
							zeroLineWidth: 1,
						},
						ticks: {
							callback(value) {
								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								return null
							}
						}
					}
				],
			},
			tooltips: {
				enabled: false,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || '';
						if (label) {
							label += ': ';
						}
						// label += Number(tooltipItem.yLabel).toLocaleString('en');
						label += "" + numberWithSpaces(tooltipItem.xLabel) + " XPF ";
						return label;
					},
				},

			},

		};
		return (
			<>
				<Spin spinning={loading}>
					<Card bordered={true}>
						<Title type="secondary" level={4}>
							{'Répartition des soldes par sociétés' + ' (' + moment(new Date(), 'DD/MM/YYYY').format('MM-YYYY') + ') :'}
						</Title>
						<HorizontalBar
							data={this.convertDataForChart(this.dataChartLimit(limitChart))}
							// width={350}
							// height={200}
							options={{
								...options,
							}}

						/>
						<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
							<Col className="gutter-row" span={5}>
								<Button
									icon="plus"
									type='link'
									style={{ width: '100%' }}
									disabled={this.state.disabledBtn}

									onClick={() => { this.setState({ setLimit: limitChart + this.state.defaultLimit, displayBtn: true }) }}
								>
									Afficher plus
								</Button>
							</Col>
							<Col className="gutter-row" span={5}>{this.setDefaultDataChart()}</Col>
						</Row>
						<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
							<Col justify='end' className="gutter-row" span={24} style={{ textAlign: 'right', color: 'grey', fontWeight: 'bold' }}>
								<div style={{ justifyContent: 'right' }}>Total: <span style={{ color: '#01AD7D' }}>{data.length} sociétés </span></div>
							</Col>
						</Row>

					</Card>

				</Spin>

			</>
		);
	}
}
